<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="版本号" prop="version">
        <el-input v-model="ruleForm.version"></el-input>
      </el-form-item>
      <el-form-item label="构建号" prop="build">
        <el-input v-model="ruleForm.build"></el-input>
      </el-form-item>
      <el-form-item label="下载地址" prop="url">
        <el-input v-model="ruleForm.url"></el-input>
      </el-form-item>
      <el-form-item label="是否强制更新" prop="isUpdate">
        <el-switch v-model="ruleForm.isUpdate"></el-switch>
      </el-form-item>
      <el-form-item label="更新日志" prop="desc">
        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">发布</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import Global from "../Global";

  export default {
    name: "releaseVersion",
    data() {
      return {
        ruleForm: {
          version: '1.0',
          build: '1.0',
          url: 'https://apps.apple.com/cn/app/stork-us/id1564682239',
          isUpdate: false,
          desc: '1.优化图像质量,2.修复一些已知问题'
        },
        rules: {
          version: [
            { required: true, message: '请输入发布版本号', trigger: 'blur' },
            { min: 5, max: 5, message: '格式为：1.0.0', trigger: 'blur' }
          ],
          build: [
            { required: true, message: '请输入构件版本号', trigger: 'blur' },
            { min: 5, max: 5, message: '格式为：1.0.0', trigger: 'blur' }
          ],
          url: [
            { required: true, message: '请输入下载地址', trigger: 'blur' },
          ],
          desc: [
            { required: true, message: '请输入下载地址，格式为：1.优化图像质量,2.修复一些已知BUG', trigger: 'blur' },
          ]
        }
      };
    },
    methods: {
      submitForm(formName) {
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.axios({
              method: 'post',
              url: Global.accountUrl + '/Apk/updateApkVersion',
              data: {
                version: that.ruleForm.version,
                build: that.ruleForm.build,
                url: that.ruleForm.url,
                description: that.ruleForm.desc,
                update: that.ruleForm.isUpdate
              }
            })
            .then(function(response){
              if(response.data.code == 200) {
                that.$message.success('发布成功');
              }
              else {
                that.$message.error('发布失败');
              }
            })
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/version/ReleaseVersion.vue